import { MessageVia } from 'services/SettingsService';

export const EMAIL: MessageVia = 'Email';
export const NONE: MessageVia = 'None';
export const TWITTER: MessageVia = 'Twitter';
export const FACEBOOK: MessageVia = 'Facebook';
export const GOOGLE: MessageVia = 'Google';
export const ALL: MessageVia = 'All';